import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing

import bayticket from '../../assets/images/about_RSVPPASS.png';
import EventOne from '../../components/Common/EventOne'; // Import the EventOne component
import { useState } from 'react';

// Example usage of the component with dynamic content
const schema = 
  {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "RSVPPASS",
  "url": "https://www.rsvppass.com",
  "logo": "https://www.rsvppass.com/assets/images/about_RSVPPASS.png",
  "foundingDate": "2001",
  "founder": {
    "@type": "Person",
    "name": "Not Specified"
  },
  "location": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "San Diego",
      "addressCountry": "US"
    }
  },
  "areaServed": [
    "USA", "UAE", "Mexico", "Europe", "Japan"
  ],
  "description": "RSVPPASS is a global event discovery platform connecting organizers, venues, sponsors, and attendees with AI-powered marketing solutions and an upcoming app launching in June 2025.",
  "slogan": "Your Event Discovery Platform",
  
  "serviceArea": {
    "@type": "Place",
    "name": "Global"
  },
  "makesOffer": [
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Event Discovery App",
        "description": "Launching June 2025, connecting millions to events, artists, and venues."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Digital Marketing",
        "description": "Affiliate marketing, funnel optimization, and multi-channel strategies."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Event Management",
        "description": "Comprehensive planning, VIP services, and sales enablement."
      }
    }
  ],
  "hasFAQPage": {
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is RSVPPASS?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "RSVPPASS is an event discovery platform connecting organizers, sponsors, venues, and attendees with AI-driven marketing and a forthcoming app."
        }
      },
      {
        "@type": "Question",
        "name": "When does the RSVPPASS app launch?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The app launches in June 2025, offering seamless event discovery for users worldwide."
        }
      },
      {
        "@type": "Question",
        "name": "Who are your partners?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We work with top events like Ultra Miami, Bonnaroo, and venues like Hakkasan, plus influencers like Rob Gronkowski."
        }
      },
      {
        "@type": "Question",
        "name": "Where is RSVPPASS located?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our headquarters is in San Diego, with operations across the USA, UAE, Mexico, and Europe."
        }
      },
      {
        "@type": "Question",
        "name": "How quickly will I hear back if I contact RSVPPASS?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We respond to inquiries within 24-48 hours."
        }
      },
      {
        "@type": "Question",
        "name": "Can I partner with RSVPPASS?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! We work with organizers, venues, sponsors, and promoters. Contact us to discuss."
        }
      },
      {
        "@type": "Question",
        "name": "What are RSVPPASS' privacy practices?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We collect data to enhance experiences and market events, with strict protections."
        }
      },
      {
        "@type": "Question",
        "name": "Who handles event refunds?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Refunds are managed by event organizers or ticketing platforms, not RSVPPASS."
        }
      },
      {
        "@type": "Question",
        "name": "Can I use RSVPPASS' content?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You need permission to use our logos, text, or other content."
        }
      }
    ]
  }
}


const points = [
    {
      icon: "icon-air-horn",
      heading: "Global Event Discovery",
      description:
        "Access events in top markets like Miami, Ibiza, Dubai, and Las Vegas, with an app launching June 2025.",
    },
    {
      icon: "icon-party-blower",
      heading: "Proven Impact",
      description:
        "Over 250,000 annual ticket sales and partnerships with iconic events like Ultra Miami and Bonnaroo.",
    },
     {
      icon: "icon-chat1",
      heading: "AI-Driven Marketing",
      description:
        "Full-stack digital solutions, including SEO, PPC, and analytics, driving transparent ROI.",
    },
     {
      icon: "icon-user",
      heading: "Trusted Network",
      description:
        "300+ partners, 1M+ contact database, and collaborations with influencers like Shaquille O’Neal.",
    },
  ];
const services = [
  {
    title: "Event Discovery App",
    description:
      "Launching June 2025, connecting millions to events, artists, and venues.",
    icon: "icon-camera"
  },
  {
    title: "Digital Marketing",
    description:
      "Affiliate marketing, funnel optimization, and multi-channel strategies.",
    icon: "icon-camera-two"
  },
  {
    title: "Event Management",
    description:
      "Comprehensive planning, VIP services, and sales enablement.",
    icon: "icon-calendar"
  },
];

const AboutMain = () => {

    const [activeIndex, setActiveIndex] = useState(null);
  
      const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
      };
    
    return (
      
        <React.Fragment>
      
        {schema && (
             <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          
        />
          )}
      

       <section className="buy-ticket">
            <div className="container">
              <div className="row">
                <div className="col-xl-6">
                  <div
                    className="buy-ticket__left wow fadeInLeft"
                    data-wow-delay="100ms"
                  >
                  
                    <h3 className="buy-ticket__title">
                      About RSVPPASS: Your Event Discovery Platform 
                    </h3>
                    <p className="buy-ticket__text">
                     Discover events, venues, and experiences with RSVPPASS, the leading platform connecting event organizers, sponsors, venues, and attendees since 2001.
                    </p>
                    <p className="buy-ticket__text"> Ready to elevate your events?</p>
                    
                    <p className="buy-ticket__text">Join our network of 300+ partners and reach millions with RSVPPASS.</p>
                    <div className="buy-ticket__btn-box">
                      Get Started Now!
                      <Link to="/contact" className="buy-ticket__btn-1 thm-btn">
                        Contact Us
                        <span className="icon-arrow-right"></span>
                      </Link>
                      {/* <Link to="/contact" className="buy-ticket__btn-2 thm-btn">
                        Contact Us<span className="icon-arrow-right"></span>
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div
                    className="buy-ticket__right wow fadeInRight"
                    data-wow-delay="300ms"
                  >
                    <div className="buy-ticket__img">
                      <img
                        src={bayticket}
                        alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </section>

        <EventOne
            tagline="About Us"
            title="Why Choose RSVPPASS? "
            points={points}
          />


        <section className="event-direction event-direction-two">
            <div className="container">
            <div className="event-direction__inner">
                <div className="row">
                <div
                    className="col-xl-12 wow fadeInLeft"
                    data-wow-delay="100ms"
                >
                    <div className="event-direction__left">
                    <div className="section-title text-left">
                       
                        <h2 className="section-title__title">
                        Our Story 
                        </h2>
                    </div>
                    <p className="event-direction__text">
                       Founded in San Diego, RSVPPASS expanded to Las Vegas, Texas, Florida, and worldwide, powering 5,000+ events annually. 
                       Our 100% commission-based model aligns our success with yours, delivering tailored solutions for event organizers, promoters, and venues.
                    </p>
                    <br/>
                    </div>
                    
                        <h2 className="section-title__title">
                        Our Global Reach 
                        </h2>
                   
                      <p className="text-center">
                       From Cancún to Tokyo, we promote events across the USA, UAE, Mexico, and Europe, ensuring maximum visibility for partners.
                      </p>
                </div>
               
                </div>
            </div>
            </div>
        </section>

          <section className="services-one services-three">
            <div className="container">
              <div className="section-title text-center">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline2">event benefits</span>
                </div>
                <h2 className="section-title__title">
                  What We Offer 
                </h2>
              </div>
              <div className="row">
                {services.map((service, index) => (
                  <div key={index} className="col-xl-4 col-lg-4">
                    <div className="services-one__single">
                      <div className="services-one__icon">
                        <span className={service.icon}></span>
                      </div>
                      <h3 className="services-one__title">
                        {service.title}
                      </h3>
                      <p className="services-one__text">
                        {service.description}
                      </p>
                     
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="faq-page">
            <div className="section-title text-center">
                <h2 className="section-title__title">
                  Frequently Asked Questions
                </h2>
              </div>
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="faq-page__left">
                    <div
                      className="accrodion-grp faq-one-accrodion"
                      data-grp-name="faq-one-accrodion-1"
                    >
                      {[
                        {
                          question: "What is RSVPPASS?",
                          answer:
                            "RSVPPASS is an event discovery platform connecting organizers, sponsors, venues, and attendees with AI-driven marketing and a forthcoming app.",
                        },
                        {
                          question: "When does the RSVPPASS app launch",
                          answer:
                            "The app launches in June 2025, offering seamless event discovery for users worldwide.",
                        },
                        {
                          question:
                            "Who are your partners?",
                          answer:
                            "We work with top events like Ultra Miami, Bonnaroo, and venues like Hakkasan, plus influencers like Rob Gronkowski.",
                        },
                          {
                          question:
                            "Where is RSVPPASS located?",
                          answer:
                            "Our headquarters is in San Diego, with operations across the USA, UAE, Mexico, and Europe.",
                        },
                        {
                          question:
                            "How quickly will I hear back if I contact RSVPPASS?",
                          answer:
                            "We respond to inquiries within 24-48 hours.",
                        },
                           {
                          question:
                            "Can I partner with RSVPPASS?",
                          answer:
                            "Yes! We work with organizers, venues, sponsors, and promoters. Contact us to discuss.",
                        },
                          {
                          question:
                            "What are RSVPPASS' privacy practices?",
                          answer:
                            "We collect data to enhance experiences and market events, with strict protections.",
                        },
                        {
                          question:
                            "Who handles event refunds?",
                          answer:
                            "Refunds are managed by event organizers or ticketing platforms, not RSVPPASS.",
                        },
                         {
                          question:
                            "Can I use RSVPPASS' content?",
                          answer:
                            "You need permission to use our logos, text, or other content.",
                        },
                        
                        
                      ].map((item, index) => (
                        <div
                          className={`accrodion ${
                            activeIndex === index ? "active" : ""
                          }`}
                          key={index}
                        >
                          <div
                            className="accrodion-title"
                            onClick={() => toggleAccordion(index)}
                          >
                            <h4>{item.question}</h4>
                            <div className="faq-one-accrodion__count"></div>
                          </div>
                          {activeIndex === index && (
                            <div className="accrodion-content">
                              <div className="inner">
                                <p>{item.answer}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </section>
        </React.Fragment>
    );
};

export default AboutMain;
